module.exports = __webpack_public_path__ + "img/history.7c1686f5.png";